import PropTypes from 'prop-types'

import {BackButton} from './components/BackButton.js'
import {Error} from './components/Error.js'
import {NextButton} from './components/NextButton.js'
import {ProgressBar} from './components/ProgressBar.js'
import {Step} from './components/Step.js'
import {StepTags} from './components/StepTags.js'
import {StepTitle} from './components/StepTitle.js'
import {BASE_CLASS} from './settings.js'

function StepperFlow({children}) {
  return <div className={BASE_CLASS}>{children}</div>
}

StepperFlow.displayName = 'StepperFlow'
StepperFlow.propTypes = {
  children: PropTypes.node.isRequired
}

StepperFlow.BackButton = BackButton
StepperFlow.Error = Error
StepperFlow.NextButton = NextButton
StepperFlow.Step = Step
StepperFlow.StepTags = StepTags
StepperFlow.StepTitle = StepTitle
StepperFlow.ProgressBar = ProgressBar

export default StepperFlow
